<template>
  <div
    v-if="special_list.length>0"
    class="box">
    <div class="">
      <span class="title">Special Clause</span>
      <p
        v-for="(special,i) in special_list"
        :key="'special'+i"
        class="special-text">
        <span class="flex-1">{{i+1+'）'}}</span>
        <span  class="flex-2"> {{special.val}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'showSpecialClause',
  props:{
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      special_list:[]
    }
  },
  computed:{
    special_clause_list(){
      let {special_clause={}}  = this.form||{}
      return  special_clause?special_clause['en-US']||[]:[]

    }
  },
  watch:{
    form:{
      immediate:true,
      deep:true,
      handler(val){
        let {special_clause={}}  = val||{}
        this.special_list =  special_clause?special_clause['en-US']||[]:[]
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .special-text{
    display: flex;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    color: #d73a49;
    .flex-1{
      flex: 1;
    }
    .flex-2{
      flex: 42;
    }
    /*margin-bottom: 20px;*/
  }
</style>
